
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  open(message: string, type: 'success' | 'error' | 'warning'): void {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top', // Set the vertical position to 'top'
      panelClass: ['snackbar-container'],
    };

    const snackBarRef = this.snackBar.openFromComponent(SnackbarComponent, {
      ...config,
      data: { message:message, type:type },
    });

    snackBarRef.afterDismissed().subscribe(() => {
      // Do something when the snackbar is dismissed (optional)
    });

    snackBarRef.onAction().subscribe(() => {
      // Do something when the action button is clicked (optional)
    });
  }
}